import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Check } from "lucide-react";

export const Roadmap = () => {
  const { t } = useLanguage();

  return (
    <section id="roadmap" className="relative py-28 md:py-36" data-testid="roadmap-section">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full bg-bicenter-blue/10 blur-[180px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-20">
          <p className="text-xs uppercase tracking-[0.4em] text-bicenter-magenta font-mono">{t.roadmap.kicker}</p>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-white leading-[1.05]">
            {t.roadmap.title}
          </h2>
          <p className="mt-6 text-lg text-zinc-400 font-body leading-relaxed">{t.roadmap.subtitle}</p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-bicenter-cyan via-bicenter-violet to-bicenter-magenta opacity-30 -translate-x-px"></div>

          <div className="space-y-12">
            {t.roadmap.phases.map((phase, i) => {
              const isRight = i % 2 === 1;
              return (
                <div
                  key={phase.name}
                  data-testid={`roadmap-phase-${i}`}
                  className={`relative grid md:grid-cols-2 gap-6 md:gap-12 items-start`}
                >
                  {/* Node */}
                  <div className="absolute left-6 md:left-1/2 top-6 w-4 h-4 rounded-full bg-gradient-to-br from-bicenter-cyan to-bicenter-violet -translate-x-1/2 ring-4 ring-[#0A0A0A] shadow-[0_0_20px_rgba(0,169,255,0.6)]"></div>

                  <div className={`pl-16 md:pl-0 ${isRight ? "md:order-2 md:pl-12" : "md:text-right md:pr-12"}`}>
                    <p className="text-xs uppercase tracking-[0.4em] text-bicenter-cyan font-mono">{phase.name}</p>
                    <p className="text-zinc-500 text-sm mt-2">{phase.period}</p>
                    <h3 className={`mt-3 font-display text-2xl md:text-3xl text-white font-medium leading-tight`}>
                      {phase.title}
                    </h3>
                  </div>

                  <div className={`pl-16 md:pl-0 ${isRight ? "md:order-1 md:pr-12 md:text-right" : "md:pl-12"}`}>
                    <ul className="space-y-3">
                      {phase.items.map((it, j) => (
                        <li
                          key={j}
                          className={`flex items-start gap-3 text-sm text-zinc-300 ${isRight ? "md:flex-row-reverse md:text-right" : ""}`}
                        >
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-gradient-to-r from-bicenter-cyan to-bicenter-violet flex-shrink-0"></span>
                          <span className="flex-1">{it}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
